<template>
  <button
    type="button"
    class="edit_profile__form_fon"
    @click.stop="Visible"
    ref="toggleBtn"
  >
    <img src="/brush.svg" alt="Brush" loading="lazy" />
    {{ $t("profileEdit.bg") }}
  </button>

  <Transition name="change_color">
    <div class="change_color" v-if="isVisible" ref="popup">
      <div class="change_color__header">
        <p>{{ $t("profileEdit.colorTitle") }}</p>
        <button @click.stop="Visible" type="button">
          <img src="/close.svg" alt="close" loading="lazy" />
        </button>
      </div>

      <div class="change_color__choises">
        <div
          class="change_color__choise"
          data-testid="color-item"
          v-for="color in colors"
          :style="
            color.type === 'solid'
              ? { background: color.colors[0] }
              : {
                  background: `linear-gradient(225deg, ${color.colors[0]} 50%, ${color.colors[1]} 50%)`,
                }
          "
          :class="{ active: isActive(color) }"
          @click="selectedColor(color)"
        ></div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { useClickOutside } from "@/composables/useClickOutside.js";

export default {
  name: "ColorPicker",
  emits: ["updateColor"],
  props: {
    bgColor: {
      type: Object,
    },
  },
  data() {
    return {
      isVisible: false,
      selectColor: this.bgColor,
      removeClickOutside: null,
      colors: [
        { id: 1, colors: ["#2196F3", "#2196F3"] },
        { id: 2, colors: ["#C70039", "#C70039"] },
        { id: 3, colors: ["#F24E1E", "#F24E1E"] },
        { id: 4, colors: ["#FFC122", "#FFC122"] },
        { id: 5, colors: ["#00BD56", "#00BD56"] },
        { id: 6, colors: ["#8688EA", "#8688EA"] },
        { id: 7, colors: ["#0D47A1", "#0D47A1"] },
        { id: 8, colors: ["#DB5050", "#DB5050"] },
        { id: 9, colors: ["#FF824D", "#FF824D"] },
        { id: 10, colors: ["#F6BD60", "#F6BD60"] },
        { id: 11, colors: ["#AADE3B", "#AADE3B"] },
        { id: 12, colors: ["#A5BDFD", "#A5BDFD"] },
        { id: 13, colors: ["#A259FF", "#A259FF"] },
        { id: 14, colors: ["#DCB5FF", "#DCB5FF"] },
        { id: 15, colors: ["#FF8B8B", "#FF8B8B"] },
        { id: 16, colors: ["#FBB799", "#FBB799"] },
        { id: 17, colors: ["#77C16A", "#77C16A"] },
        { id: 18, type: "gradient", colors: ["#CCCCCC", "#909090"] },
        { id: 19, type: "gradient", colors: ["#343434", "#5F5F5F"] },
        { id: 20, type: "gradient", colors: ["#950C3F", "#C3023A"] },
        { id: 21, type: "gradient", colors: ["#F45525", "#FE7945"] },
        { id: 22, type: "gradient", colors: ["#FFAC01", "#FFCA01"] },
        { id: 23, type: "gradient", colors: ["#31A554", "#7CDC2A"] },
        { id: 24, type: "gradient", colors: ["#3D3598", "#2F5AC3"] },
        { id: 25, type: "gradient", colors: ["#7331AA", "#A35FFA"] },
        { id: 26, type: "gradient", colors: ["#C60F4C", "#F9A093"] },
        { id: 27, type: "gradient", colors: ["#FF8F8C", "#FCB599"] },
        { id: 28, type: "gradient", colors: ["#FEAD4F", "#FFC683"] },
        { id: 29, type: "gradient", colors: ["#7CC46E", "#B9D9A1"] },
        { id: 30, type: "gradient", colors: ["#4E86CF", "#86A4EF"] },
        { id: 31, type: "gradient", colors: ["#A4B2FF", "#B3A1FF"] },
        { id: 32, type: "gradient", colors: ["#A50F64", "#B03F9A"] },
        { id: 33, type: "gradient", colors: ["#F49BC0", "#E26FA5"] },
        { id: 34, type: "gradient", colors: ["#F6AA32", "#F7125B"] },
        { id: 35, type: "gradient", colors: ["#2CB9AC", "#CFD9AF"] },
        { id: 36, type: "gradient", colors: ["#F2F2F2", "#151515"] },
      ],
    };
  },
  watch: {
    bgColor: {
      handler(val) {
        this.selectColor = val;
      },
      deep: true,
    },
  },
  methods: {
    Visible() {
      this.isVisible = !this.isVisible;
    },
    selectedColor(color) {
      this.selectColor = color;
      this.$emit("updateColor", color);
    },
    isActive(color) {
      return (
        color.colors[0] === this.selectColor.colors[0] &&
        color.colors[1] === this.selectColor.colors[1]
      );
    },
  },
  mounted() {
    this.removeClickOutside = useClickOutside(this.$el, (e) => {
      if (this.$refs.toggleBtn?.contains(e.target)) return;

      this.isVisible = false;
    });
  },
  beforeUnmount() {
    this.removeClickOutside?.();
  },
};
</script>

<style>
.change_color {
  position: absolute;
  background-color: var(--color-picker-bg);
  border-radius: 25px;
  top: 50px;
  left: -180px;
  max-width: 368px;
  z-index: 3;
  padding: 16px;
  backdrop-filter: blur(100px);
  -webkit-backdrop-filter: blur(15px);
  box-shadow:
    -1px -1px 0 rgba(255, 255, 255, 0.1),
    1px 1px 0 rgba(185, 185, 185, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.change_color__header {
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
  color: white;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
}

.change_color__header button {
  background: rgba(0, 0, 0, 0.2);
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.change_color__header button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.change_color__header button img {
  width: 13px;
  height: 13px;
}

.change_color__choises {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.change_color__choise {
  border-radius: 12px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
}

.change_color__choise.active {
  border: 4px solid white;
}

.change_color__choise:hover {
  opacity: 50%;
}

.change_color-enter-active,
.change_color-leave-active {
  transition: all 0.2s ease;
}

.change_color-enter-from,
.change_color-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.change_color-enter-to,
.change_color-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

@media (max-width: 380px) {
  .change_color {
    left: -150px;
  }
}
</style>
